import Vue from 'vue'
import Vuex from 'vuex'
import AuthStore from './modules/auth.store'
import SessionStore from './modules/session.store'
import LanguageStore from './modules/language.store'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		auth: AuthStore,
		session: SessionStore,
		language: LanguageStore,
	},
	state: {
	},
	getters: {
	},
	mutations: {
	},
	actions: {
	}
})

